import React from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Typography,
  Dialog as MUIDialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  LinearProgress,
} from '@mui/material';

import { Flex } from '../../components';

export const BBDialog = ({
  children,
  isOpen,
  isLoading,
  onClose,
  title,
  subtitle,
  actions,
  titleActions,
  size = 'xl',
}) => {
  return (
    <MUIDialog
      disableEscapeKeyDown
      fullWidth
      open={isOpen}
      maxWidth={size}
      onClose={(event, reason) => {
        if (reason && reason === 'backdropClick') return;
        onClose?.(event);
      }}
    >
      <DialogTitle sx={{ padding: '20px' }}>
        <Flex.H sx={{ justifyContent: 'space-between', gap: '20px' }}>
          {(title || subtitle) && (
            <Flex.H sx={{ alignItems: 'center', gap: '20px' }}>
              {title && <Typography variant="h1">{title}</Typography>}

              {subtitle && <Typography variant="h5">{subtitle}</Typography>}
            </Flex.H>
          )}

          <Flex.H sx={{ alignItems: 'center', gap: '20px' }}>
            {titleActions}

            {onClose && (
              <Box>
                <IconButton
                  aria-label="close"
                  onClick={() => {
                    onClose?.();
                  }}
                  size="large"
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
          </Flex.H>
        </Flex.H>
      </DialogTitle>

      <DialogContent dividers sx={{ padding: '40px' }}>
        {isLoading && <LinearProgress sx={{ margin: '-40px -40px 20px' }} />}
        {children}
      </DialogContent>

      {actions && <DialogActions sx={{ padding: '20px' }}>{actions}</DialogActions>}
    </MUIDialog>
  );
};

BBDialog.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.any,
  actions: PropTypes.any,
  titleActions: PropTypes.any,
  size: PropTypes.string,
};
